// "Username: <name>" with a Copy button, in Settings > Account and the island's You panel. Staff ask
// students for this name (to add them to the beta program, for one), and before this line the only
// place it showed was inside Study Hall and the leaderboard. It shows the public username and
// nothing else: never the account ID, an email address or a sign-in token.

// Copies text, falling back to selecting it (a school policy can block the clipboard API) and then
// execCommand. Resolves true when it copied; on false the text is left selected for Ctrl+C.
export function copyText(text, node) {
	const select = () => {
		try {
			const r = document.createRange();
			r.selectNodeContents(node);
			const s = getSelection();
			s.removeAllRanges();
			s.addRange(r);
			return document.execCommand("copy");
		} catch { return false; }
	};
	const c = navigator.clipboard;
	return c && c.writeText ? c.writeText(text).then(() => true, select) : Promise.resolve(select());
}

// standing: a promise of GET /account/handle's answer ({ handle, ... }). onPick: where "pick one"
// goes (the form below, or Settings from the island). line.set(handle) repaints it after a save.
export function usernameLine(standing, { onPick, cls = "rv-account-note", btnCls = "rv-btn", k } = {}) {
	const line = document.createElement("p");
	line.className = cls + " rv-username-line";
	const btn = (text, run) => {
		const b = document.createElement("button");
		b.type = "button";
		b.className = btnCls;
		b.textContent = text;
		if (k) b.dataset.k = k;
		b.addEventListener("click", run);
		return b;
	};
	const set = (handle) => {
		line.textContent = "";
		if (!handle) {
			line.append("No username yet: ");
			if (onPick) line.append(btn("pick one", onPick));
			else line.append("pick one in Settings > Account.");
			return;
		}
		const name = document.createElement("strong");
		name.className = "rv-username";
		name.textContent = handle;
		const copy = btn("Copy", () => {
			copyText(handle, name).then((ok) => {
				copy.textContent = ok ? "Copied" : "Press Ctrl+C";
				setTimeout(() => { copy.textContent = "Copy"; }, 2500);
			});
		});
		copy.setAttribute("aria-label", "Copy your username");
		line.append("Username: ", name, " ", copy);
	};
	// A save that lands before the first load finishes wins over the older answer.
	let saved = false;
	line.textContent = "Loading your username...";
	line.set = (handle) => { saved = true; set(handle); };
	Promise.resolve(standing).then((s) => { if (!saved) set(s && s.handle); }, () => { if (!saved) line.textContent = "Couldn't load your username. Try again in a moment."; });
	return line;
}
